<template>
    <div>
        <h1 class="page-title">{{ $t("catalogue.documents.title") }}</h1>
        <div class="flex mb-4 justify-end space-x-4">
            <router-link
                class="group inline-flex items-center justify-center rounded-lg py-2 px-6 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600"
                to="/admin/addDocument"
            >
                <i class="pi pi-upload mr-2"></i> Importer des documents
            </router-link>
            <button
                @click="downloadCsv"
                class="group inline-flex items-center justify-center rounded-lg py-2 px-6 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600"
            >
                <i class="pi pi-download mr-2"></i> Export de stock
            </button>
        </div>

        <TabView v-model:activeIndex="selectedTabIndex">
            <TabPanel header="Disponibles">
                <StockAvailableList :data="availableData" />
            </TabPanel>
            <TabPanel header="Non disponibles">
                <StockNotAvailableList :data="notAvailableData" />
            </TabPanel>
            <TabPanel header="Stock de documents">
                <StockDocumentList :data="stockData" />
            </TabPanel>
            <TabPanel header="Stock vierge">
                <StockDocumentNotAvailableList />
            </TabPanel>
        </TabView>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import StockDocumentList from "@/components/product/document/StockDocumentList.vue";
import StockAvailableList from "@/components/product/document/StockAvailableList.vue";
import StockNotAvailableList from "@/components/product/document/StockNotAvailableList.vue";
import StockDocumentNotAvailableList from '@/components/product/document/StockDocumentNotAvailableList.vue';
import ApiService from "@/_services/api.service";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';


const selectedTabIndex = ref(0);
const stockData = ref([]);
const availableData = ref([]);
const notAvailableData = ref([]);
const isLoading = ref<boolean>(true);

function generateFilename() {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const day = `${now.getDate()}`.padStart(2, '0');
    const hour = `${now.getHours()}`.padStart(2, '0');
    const minute = `${now.getMinutes()}`.padStart(2, '0');

    return `export_stocks_${month}_${day}_${year}_${hour}_${minute}.csv`;
}

async function downloadCsv() {
    try {
        const response = await ApiService.get('variant_product_documents/export', { responseType: 'blob' });
        const filename = generateFilename();
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Erreur lors du téléchargement:', error);
    }
}
</script>
<style>
.p-tabview-nav li.p-highlight .p-tabview-title {
    color: black !important; 
}
.p-tabview-nav li:not(.p-highlight) .p-tabview-title {
    color: lightgrey !important;
}
</style>

